import { render, staticRenderFns } from "./MobileCommunityHealthInfoUpdate.vue?vue&type=template&id=2ff06936&"
import script from "./MobileCommunityHealthInfoUpdate.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityHealthInfoUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityHealthInfoUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports